import $ from "jquery";
import { Board, PATH, Point } from "./board";

let bili = window.innerHeight / 1080; // 比例

/* eslint-disable max-params */
// canvas obj
let _canvas = null;
// context obj
let _ctx = null;
// face image obj
let _img_face = null;

// face img size
let _img_face_m = 0; // 原始图有几列
let _img_face_n = 0; // 原始图有几排
let _img_face_src_width = 0;
let _img_face_src_height = 0;
let _img_face_width = 0;
let _img_face_height = 0;
let _img_face_radius = 0;

// board size
let _board_m = 8; // 显示几列
let _board_n = 5; // 显示几行
let _boardsize = 0;
let _board_m_offset = 0;
let _board_n_offset = 0;

// board obj
let _board = null;

// canvas size
let _width = 0;
let _height = 0;

// first selected face
let _first_p = null;
// last moveout face
let _old_p = null;

// animation flag
let _is_play_animation = false;

// board state flag
// 0: start
// 1: pause
// 2: stop
let _board_state = 0;

// current time

var _timer_time = null; // 倒计时定时器
let remaining_time = null;
let _current_time = 2 * 60 * 1000 + 30 * 1000; // 2分30秒
let gaunqa = 1;
// 检测是否为移动设备
function isMobile() {
  let t = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  return t && window.innerWidth < 1920;
}
// entry point
export let gameinit = function (_img, _type) {
  // face img resource size

  _img_face_src_width = 129;
  _img_face_src_height = 129;

  // 根据设备类型设置不同的半径
  _img_face_radius = 6 * bili;

  if (_type === "1") {
    _img_face_m = 9; // 原始图有几列
    _img_face_n = 3; // 原始图有几排
  }
  if (_type === "2") {
    _img_face_m = 8; // 原始图有几列
    _img_face_n = 4; // 原始图有几排
  }
  // // calc canvas size
  // _width = (16 + 2) * _img_face_width;
  // _height = (9 + 2) * _img_face_height;

  // get canvas obj
  _canvas = document.getElementById("canvas");

  if (_canvas != null && _canvas.getContext != null) {
    // _canvas.width = _width;
    // _canvas.height = _height;
    _ctx = _canvas.getContext("2d");
    _ctx.imageSmoothingEnabled = false; // 禁用cavans的平滑处理
    _ctx.mozImageSmoothingEnabled = true; // 适用于Firefox
    _ctx.webkitImageSmoothingEnabled = true; // 适用于Chrome, Safari
    _ctx.imageSmoothingQuality = "high";
    _ctx.save();

    _canvas.onmousemove = OnCanvas_MouseMove;
    _canvas.onmousedown = OnCanvas_Click;
  }

  _img_face = _img;
  btnNewGame_Click(1, _img_face); // 从第一关开始
};

// event
function btnNewGame_Click(guan, _img_face) {
  if (_is_play_animation) return;

  _board_state = 0;

  _img_face_width = 129 * bili; // 单个显示的宽度
  _img_face_height = 129 * bili; // 单个显示的高度

  _first_p = null;
  _old_p = null;

  _width = (_board_m + 1) * _img_face_width;
  _height = (_board_n + 1) * _img_face_height;
  // _board_m_offset = (_width - (_board_m + 2) * _img_face_width) / 2;
  // _board_n_offset = (_height - (_board_n + 2) * _img_face_height) / 2;

  _board_m_offset = Math.round((_width - (_board_m + 2) * _img_face_width) / 2);
  _board_n_offset = Math.round(
    (_height - (_board_n + 2) * _img_face_height) / 2
  );

  // console.log(window.devicePixelRatio);
  if (_ctx != null) {
    if (isMobile()) {
      _canvas.width = _width;
      _canvas.height = _height;
    } else {
      _canvas.width = _width * window.devicePixelRatio;
      _canvas.height = _height * window.devicePixelRatio;
    }

    // _canvas.width = window.innerWidth;
    // _canvas.height = _height;
    _ctx.restore();
    _ctx.save();
    _ctx.clearRect(0, 0, _width, _height);
    _ctx.translate(_board_m_offset, _board_n_offset);
  }
  _board = null;
  _board = new Board();
  _board.Init(_board_m, _board_n, _img_face_m * _img_face_n);
  // }

  _board.NewGame();

  if (_ctx != null) {
    draw_board();
  }

  clearMyTime();
  // _current_time = 5 * 1000; // 2分30秒
  remaining_time = _current_time;
  draw_time();
}

export function btnHint_Click() {
  if (_is_play_animation) return;
  if (_board_state > 0) return;

  if (_board != null) {
    let path = new PATH();
    if (_board.GetHint(path) && _ctx != null) {
      // draw path
      draw_face_animation(path.Start.X, path.Start.Y, "#f3cd2b");
      draw_face_animation(path.End.X, path.End.Y, "#f3cd2b");
      draw_path(path, "#f3cd2b");

      _is_play_animation = true;

      setTimeout(function () {
        _is_play_animation = false;

        // erase path
        erase_path(path);

        // draw face
        draw_face(
          _board.FaceItems[path.Start.X][path.Start.Y],
          path.Start.X,
          path.Start.Y
        );
        draw_face(
          _board.FaceItems[path.End.X][path.End.Y],
          path.End.X,
          path.End.Y
        );
      }, 1000);
    }
  }
}

function OnCanvas_MouseMove(e) {
  if (_is_play_animation) return;
  if (_board_state > 0) return;

  if (!e.offsetX) {
    let offsetP = calc_offset(_canvas);
    e.offsetX = e.pageX - offsetP.X;
    e.offsetY = e.clientY - offsetP.Y;
  }
  let x = e.offsetX - _board_m_offset;
  let y = e.offsetY - _board_n_offset;
  let board_p = point2board(x, y);

  if (_ctx != null) {
    // revert old animation
    if (
      _first_p != null &&
      _old_p != null &&
      _first_p.X === _old_p.X &&
      _first_p.Y === _old_p.Y
    ) {
      // old == first
    } else {
      // != old
      if (
        _old_p != null &&
        (board_p == null || !(_old_p.X === board_p.X && _old_p.Y === board_p.Y))
      ) {
        draw_face(_board.FaceItems[_old_p.X][_old_p.Y], _old_p.X, _old_p.Y);
      }
    }

    // draw new animation
    if (board_p != null && _board.FaceItems[board_p.X][board_p.Y] > 0) {
      // !=selected face
      if (
        _first_p == null ||
        (_first_p != null &&
          !(_first_p.X === board_p.X && _first_p.Y === board_p.Y))
      ) {
        draw_face_animation(board_p.X, board_p.Y, "#f3cd2b");
        _old_p = board_p;
      }
    }
  }
}

function OnCanvas_Click(e) {
  if (e.button != 0) return; // 1 for left button
  if (_is_play_animation) return;
  if (_board_state > 0) return;
  if (!e.offsetX) {
    let offsetP = calc_offset(_canvas);
    e.offsetX = e.pageX - offsetP.X;
    e.offsetY = e.pageY - offsetP.Y;
  }
  let x = e.offsetX - _board_m_offset;
  let y = e.offsetY - _board_n_offset;
  let board_p = point2board(x, y);
  if (board_p == null) return;
  if (_board.FaceItems[board_p.X][board_p.Y] <= 0) return;
  if (_first_p == null) {
    _first_p = board_p;
    draw_face_animation(board_p.X, board_p.Y, "#f3cd2b");
  } else if (_first_p.X == board_p.X && _first_p.Y == board_p.Y) return;
  else {
    let path = new PATH();
    path.Start.X = _first_p.X;
    path.Start.Y = _first_p.Y;
    path.End.X = board_p.X;
    path.End.Y = board_p.Y;
    if (_board.IsFit(path)) {
      if (_ctx != null) {
        draw_face_animation(path.End.X, path.End.Y, "#f3cd2b");
        draw_solve_process(path);
      }
    } else {
      draw_face(
        _board.FaceItems[_first_p.X][_first_p.Y],
        _first_p.X,
        _first_p.Y
      );
      _first_p.X = board_p.X;
      _first_p.Y = board_p.Y;
      draw_face_animation(board_p.X, board_p.Y, "#f3cd2b");
    }
  }
}

// draw to UI
function draw_board() {
  _ctx.clearRect(0, 0, _width, _height);
  for (let i = 0; i < _board_m + 2; i++) {
    for (let j = 0; j < _board_n + 2; j++) {
      draw_face(_board.FaceItems[i][j], i, j);
    }
  }
}

function draw_face(i, board_x, board_y) {
  let faceNum = img_face_number(i);
  if (faceNum == null) return;

  let m = faceNum.X;
  let n = faceNum.Y;

  _ctx.drawImage(
    _img_face,
    Math.floor(m * _img_face_src_width),
    Math.floor(n * _img_face_src_height),
    Math.floor(_img_face_src_width),
    Math.floor(_img_face_src_height),
    Math.floor(board_x * _img_face_width),
    Math.floor(board_y * _img_face_height),
    Math.floor(_img_face_width),
    Math.floor(_img_face_height)
  );
}

function draw_face_animation(board_x, board_y, color, isCanceled) {
  _ctx.save();
  // 执行绘制
  _ctx.lineWidth = 4 * bili;
  _ctx.strokeStyle = color;
  if (isMobile()) {
    roundedRectStroke(
      _ctx,
      board_x * _img_face_width,
      board_y * _img_face_height,
      _img_face_width,
      _img_face_height,
      _img_face_radius
    );
  } else {
    roundedRectStroke(
      _ctx,
      Math.floor(board_x * _img_face_width + 2 * bili),
      Math.floor(board_y * _img_face_height + 2 * bili),
      window.innerWidth >= 3840
        ? Math.floor(_img_face_width - 16 * bili)
        : Math.floor(_img_face_width - 10 * bili),
      window.innerWidth >= 3840
        ? Math.floor(_img_face_width - 16 * bili)
        : Math.floor(_img_face_height - 10 * bili),
      Math.floor(_img_face_radius)
    );
  }

  _ctx.restore();
}

export function clearMyTime() {
  if (_timer_time != null) {
    clearInterval(_timer_time);
    _timer_time = null;
  }
  // remaining_time = _current_time;
  $(".jindu .percent")
    .css({
      width: "100%",
      transition: "none",
    })
    .promise()
    .done(function () {
      // 确保CSS变更生效后再移除过渡
      $(this).css("transition", "");
    });
  $(".box .text").text(format_time(2 * 60 + 30)); // 使用统一的时间格式化函数
}

function draw_solve_process(path) {
  // draw path
  draw_path(path, "#f3cd2b");

  _is_play_animation = true;

  setTimeout(function () {
    _is_play_animation = false;

    // draw path
    erase_path(path);
    _board.ErasePair(path);
    _first_p = null;

    // check
    if (_board.IsSuccessFinish()) {
      // set board state
      console.log("闯关成功", gaunqa);

      _board_state = 2;
      clearMyTime();
      $(".successbox").show();
      // if (gaunqa === 3) {
      //   console.log("通关成功");
      //   window.gaunqa = 1;
      // }
    } else {
      if (!_board.GetHint(path)) {
        for (let i = 0; i < 1000; i++) {
          _board.RearrangeBoard();
          if (_board.GetHint(path)) {
            draw_board();
            break;
          }
        }
      }
    }
  }, 100);
}

function draw_time() {
  // console.log(1, remaining_time);

  // 创建新计时器
  _timer_time = setInterval(function () {
    remaining_time -= 1000;
    updateTimeDisplay();
    // console.log(remaining_time);
    if (remaining_time <= 0) {
      clearMyTime();
      console.log("失败");
      $(".failedbox").show();
    }
  }, 1000);
}

// 新增时间显示更新函数
function updateTimeDisplay() {
  const minutes = Math.floor(remaining_time / 60000);
  const seconds = Math.floor((remaining_time % 60000) / 1000);

  // 更新文本
  $(".box .text").text(`${minutes}:${seconds < 10 ? "0" + seconds : seconds}`);

  // 更新进度条
  const percent = (remaining_time / _current_time) * 100;
  $(".jindu .percent").css("width", `${percent}%`);
}

// 统一的时间格式化函数（可替代原有格式化逻辑）
function format_time(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
}
function draw_path(path, color) {
  _ctx.save();
  _ctx.save();
  _ctx.fillStyle = "transparent";
  _ctx.fillRect(
    path.Start.X * _img_face_width,
    path.Start.Y * _img_face_height,
    _img_face_width,
    _img_face_height
  );
  _ctx.fillRect(
    path.End.X * _img_face_width,
    path.End.Y * _img_face_height,
    _img_face_width,
    _img_face_height
  );
  _ctx.restore();

  _ctx.globalCompositeOperation = "destination-over";

  _ctx.lineWidth = 3;
  _ctx.lineCap = "round";
  _ctx.lineJoin = "round";
  _ctx.strokeStyle = color;
  _ctx.beginPath();
  _ctx.moveTo(
    path.Start.X * _img_face_width + _img_face_width / 2,
    path.Start.Y * _img_face_height + _img_face_height / 2
  );
  _ctx.lineTo(
    path.MidOne.X * _img_face_width + _img_face_width / 2,
    path.MidOne.Y * _img_face_height + _img_face_height / 2
  );
  _ctx.lineTo(
    path.MidTwo.X * _img_face_width + _img_face_width / 2,
    path.MidTwo.Y * _img_face_height + _img_face_height / 2
  );
  _ctx.lineTo(
    path.End.X * _img_face_width + _img_face_width / 2,
    path.End.Y * _img_face_height + _img_face_height / 2
  );
  _ctx.stroke();

  _ctx.restore();
}

function erase_path(path) {
  erase_from_to(path.Start, path.MidOne);
  erase_from_to(path.MidOne, path.MidTwo);
  erase_from_to(path.MidTwo, path.End);
}

// function erase_from_to(from, to) {
//   if (from.X < to.X) {
//     _ctx.clearRect(
//       from.X * _img_face_width,
//       from.Y * _img_face_height,
//       _img_face_width * (to.X - from.X + 1),
//       _img_face_height * (to.Y - from.Y + 1)
//     );
//   } else if (from.X > to.X) {
//     _ctx.clearRect(
//       to.X * _img_face_width,
//       to.Y * _img_face_height,
//       _img_face_width * (from.X - to.X + 1),
//       _img_face_height * (from.Y - to.Y + 1)
//     );
//   } else {
//     if (from.Y < to.Y) {
//       _ctx.clearRect(
//         from.X * _img_face_width,
//         from.Y * _img_face_height,
//         _img_face_width * (to.X - from.X + 1),
//         _img_face_height * (to.Y - from.Y + 1)
//       );
//     } else {
//       _ctx.clearRect(
//         to.X * _img_face_width,
//         to.Y * _img_face_height,
//         _img_face_width * (from.X - to.X + 1),
//         _img_face_height * (from.Y - to.Y + 1)
//       );
//     }
//   }
// }
function erase_from_to(from, to) {
  const x1 = Math.min(from.X, to.X) * _img_face_width;
  const y1 = Math.min(from.Y, to.Y) * _img_face_height;
  const x2 = Math.max(from.X, to.X) * _img_face_width;
  const y2 = Math.max(from.Y, to.Y) * _img_face_height;
  if (isMobile()) {
    _ctx.clearRect(
      x1,
      y1,
      x2 - x1 + _img_face_width,
      y2 - y1 + _img_face_height
    );
  } else {
    _ctx.clearRect(
      x1 - 2,
      y1 - 2,
      x2 - x1 + _img_face_width + 4,
      y2 - y1 + _img_face_height + 4
    );
  }
}
function roundedRectStroke(ctx, x, y, width, height, radius) {
  x += 2;
  y += 2;
  width -= 9;
  height -= 9;
  ctx.beginPath();
  roundedRectCore(ctx, x, y, width, height, radius);
  ctx.stroke();
}

function roundedRectFill(ctx, x, y, width, height, radius) {
  x += 2;
  y += 2;
  width -= 4;
  height -= 4;
  ctx.beginPath();
  roundedRectCore(ctx, x, y, width, height, radius);
  ctx.fill();
}

function roundedRectCore(ctx, x, y, width, height, radius) {
  ctx.moveTo(x, y + radius);
  ctx.lineTo(x, y + height - radius);
  ctx.quadraticCurveTo(x, y + height, x + radius, y + height);
  ctx.lineTo(x + width - radius, y + height);
  ctx.quadraticCurveTo(x + width, y + height, x + width, y + height - radius);
  ctx.lineTo(x + width, y + radius);
  ctx.quadraticCurveTo(x + width, y, x + width - radius, y);
  ctx.lineTo(x + radius, y);
  ctx.quadraticCurveTo(x, y, x, y + radius);
}

// utility function
function point2board(x, y) {
  let gridPoint = new Point();
  gridPoint.X = double2int(x / _img_face_width);
  gridPoint.Y = double2int(y / _img_face_height);

  // check we're not out of bounds
  if (
    gridPoint.X > _board_m ||
    gridPoint.Y > _board_n ||
    gridPoint.X < 1 ||
    gridPoint.Y < 1
  ) {
    gridPoint = null;
  }
  return gridPoint;
}

function img_face_number(i) {
  // when bound, return
  if (i <= 0) return null;

  let gridPoint = new Point();
  i = (i - 1) % (_img_face_m * _img_face_n);
  gridPoint.X = i % _img_face_m;
  gridPoint.Y = double2int(i / _img_face_m);

  return gridPoint;
}

function calc_offset(element) {
  if (element == null) return null;

  let offsetP = new Point();
  let cur = element;
  offsetP.X = cur.offsetLeft;
  offsetP.Y = cur.offsetTop;

  while (cur.offsetParent != null) {
    cur = cur.offsetParent;
    if (cur.offsetLeft) {
      offsetP.X += cur.offsetLeft;
      offsetP.Y += cur.offsetTop;
    }
  }

  return offsetP;
}

// support Number and String
function double2int(x) {
  // return x > 0 ? Math.floor(x) : Math.ceil(x);
  // return parseInt(x);
  // return ~~x;
  return 0 | x;
}

export function btnOrder_Click() {
  if (_is_play_animation) return;
  if (_board_state == 2) return;
  if (localStorage == null || _ctx == null) return;

  if (_timer_time != null) {
    _board_state = 1;
    $(".startorstop .txt").text("恢复游戏");
    $(".startorstop").removeClass("stop").addClass("start");
    // pause timer
    clearInterval(_timer_time);
    _timer_time = null;
  } else {
    _board_state = 0;
    $(".startorstop .txt").text("暂停游戏");
    $(".startorstop").removeClass("start").addClass("stop");
    // restart timer
    draw_time();
  }
}
export function pailie() {
  setTimeout(() => {
    for (let i = 0; i < 1000; i++) {
      _board.RearrangeBoard();
      // console.log("重新排列");
      draw_board();
      break;
    }
  }, 100);
}
